import React from 'react';
import UserAvatar from '@/app/components/user_avatar/widget';
import Button from '@/app/components/button';
import LazyAssets from '@/app/utils/assets_widget';
import classNames from 'classnames';
import styles from '../styles.module.scss';

interface ProfilePhotoProps {
  imageLink?: string;
  username: string;
  photoBase64?: string;
  onUploadPhoto: () => void;
  className?: string;
}

/**
 * Component for displaying and managing user profile photo
 */
const ProfilePhoto: React.FC<ProfilePhotoProps> = ({
  imageLink,
  username,
  photoBase64,
  onUploadPhoto,
  className,
}) => {
  return (
    <div className={classNames(styles.block, styles.center, className)}>
      <div className={styles.userPhoto}>
        <UserAvatar 
          userAvatar={imageLink} 
          userName={username}
          userAvatarInBase64={photoBase64}
        />
      </div>
      <Button 
        icon={<LazyAssets.AddAPhoto />} 
        onClick={onUploadPhoto} 
        className={styles.button} 
        isOutline 
        circle
      />
    </div>
  );
};

export default ProfilePhoto;